import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { ipcApi } from "utils"
import { Select } from "components"
import classes from "./PrinterDriversList.module.scss"

const PrinterDriversList = props => {
  const { form, setForm, formErrors } = props

  const [t] = useTranslation()

  const [options, setOptions] = useState([])

  const handleSelect = (select) => {
    setForm(prev => ({
      ...prev,
      deviceName: select.value
    }))
  }

  const handleFocus = async () => {
    try {
      const devices =
        await ipcApi({
          type: "getPrintersDriver"
        })

      const options =
        devices.map(device => ({
          label: device.name,
          value: device.name
        }))

      setOptions(options)
    } catch (err) {
      console.log(err)
    }
  }

  const getDriverDevicesList = async () => {
    const devices =
      await ipcApi({
        type: "getPrintersDriver"
      })

    const options =
      devices.map(device => ({
        label: device.name,
        value: device.name
      }))

    setOptions(options)
  }

  useEffect(() => {
    getDriverDevicesList()
  }, [])

  const value =
    options.find(o => o.value === form.deviceName)
    ||
    (
      !!form.deviceName
        ?
        {
          label: form.deviceName,
          value: form.deviceName
        }
        :
        null
    )

  return (
    <Select
      value={value}
      isSearchable={false}
      options={options}
      onMenuOpen={handleFocus}
      onChange={handleSelect}
      noOptionsMessage={() => t("هیچ_پرینتی_یافت_نشد")}
      placeholder={t("انتخاب_پرینتر")}
      className={classes["select"]}
      error={formErrors.deviceName}
    />
  )
}

export default PrinterDriversList